import { useCheckPermissionList } from "@/domain/_shared/permission/hooks/api/use-check-permission-list";
import { ACTION_TYPES, type ActionType } from "@/domain/_shared/permission/models/permission-types";
import { useTeamListForWorkspace } from "@/domain/team/hooks/api/use-team-list-for-workspace";
import { useGetUserFavoriteList } from "@/domain/user/hooks/api/use-get-user-favorite";
import { useGetUserListForWorkspace } from "@/domain/user/hooks/api/use-get-user-list";
import { useGetActiveViewList } from "@/domain/view/hooks/api/use-get-active-view-list";
import { useWorkspaceSettings } from "@/domain/workspace/hooks/api/use-workspace-settings";

interface UsePreLoaderNonBlockingProps {
  workspaceId: string;
}

export const usePreLoaderNonBlocking = ({ workspaceId }: UsePreLoaderNonBlockingProps) => {
  void useGetUserListForWorkspace({
    workspaceId,
  });

  void useGetActiveViewList({
    workspaceId,
  });

  // Warm user favorites cache (non-critical for initial render)
  void useGetUserFavoriteList({
    workspaceId,
  });

  // Warm workspace settings cache (already initiated by parent layout)
  void useWorkspaceSettings({ workspaceId });

  // Team-level permissions are fetched after team list loads - moved here
  // to avoid waterfall blocking (team list ~1.4s + permissions ~0.5s)
  const teamQueryResults = useTeamListForWorkspace({
    workspaceId,
  });

  void useCheckPermissionList({
    permissions: teamQueryResults.teamList.flatMap((team) => {
      return ACTION_TYPES.map((action) => ({
        resource: "team",
        action: action as ActionType,
        resourceId: team.id,
      }));
    }),
  });

  return {};
};
